import React from 'react';
import { useTranslation } from '../../i18n/useTranslation';
import './About.css';

const About = () => {
  const { t } = useTranslation();
  const raw = t('about.features');
  const features = Array.isArray(raw) ? raw : [];

  return (
    <section id="about" className="section">
      <div className="container">
        <div className="about__grid">
          <div className="about__content">
            <h2 className="section-title">{t('about.title')}</h2>
            <p className="about__text">{t('about.text1')}</p>
            <p className="about__text">{t('about.text2')}</p>
            <div className="about__features">
              {features.map((feature, index) => (
                <div key={index} className="about__feature">
                  <span className="about__feature-icon">{feature.icon || ''}</span>
                  <div>
                    <strong>{feature.title || ''}</strong>
                    <p>{feature.text || ''}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="about__image">
            <div className="about__image-wrapper">
              <img
                src="/images/about.jpg"
                alt={t('about.imageTitle')}
                className="about__image-photo"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div className="about__image-fallback" style={{ display: 'none' }}>
                <span>🏗️</span>
                <p>{t('about.imageTitle')}</p>
              </div>
            </div>
            <div className="about__image-badge">
              <span className="about__image-badge-number">10+</span>
              <span className="about__image-badge-text">{t('about.yearsLabel')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;